// Gürsoy Kargo (Webpostman) REST API sağlayıcısı.
// FEST'in yeni birimi; FEST, Deposel ve Soyalp ile AYNI Webpostman altyapısını kullanır. Endpoint'ler
// (consignment/add, edit, delete, tracking, cargo), kimlik doğrulama (Authorization + From header),
// form-urlencoded gövde, statü kodları (00-60) ve durum kovaları (0-6) birebir aynıdır. Tek fark taban
// URL'dir; kargo firması/şube kodları cari başına UI'dan girilir (veri farkı, kod farkı değil).
// DİKKAT: sunucu IPv6 istemcide yanıtın başına PHP uyarısı (HTML) basar — ayrıştırıcı bunu kırpar
// (webpostman.ts parseResponseText).
import { createWebpostmanProvider } from './webpostman'

const GURSOY_BASE = 'https://wp.gursoycargo.com/restapi/client'

export const gursoyProvider = createWebpostmanProvider('gursoy', GURSOY_BASE)
